// Task sizes and priorities in words, for the read-only Plan and Board views. The staff app has its
// own copy (frontend/staff/src/lib/agile.ts), which the portal can't import.
import type { BadgeKind } from "@corecrm/ui";
import type { TaskPriority, TaskSize } from "../api/types";

export const SIZE_LABEL: Record<TaskSize, string> = {
  xs: "X-Small",
  s: "Small",
  m: "Medium",
  l: "Large",
  xl: "X-Large",
  xxl: "XX-Large",
  xxxl: "XXX-Large",
};

export const SIZE_POINTS: Record<TaskSize, number> = {
  xs: 1,
  s: 2,
  m: 3,
  l: 5,
  xl: 8,
  xxl: 13,
  xxxl: 21,
};

/** "Medium (3)". */
export const sizeLabel = (size: TaskSize) => `${SIZE_LABEL[size]} (${SIZE_POINTS[size]})`;

export const PRIORITY: Record<TaskPriority, [string, BadgeKind]> = {
  urgent: ["Urgent", "bad"],
  high: ["High", "warn"],
  medium: ["Medium", "info"],
  low: ["Low", "mute"],
};

/** "3 pts", "1 pt". */
export const points = (n: number) => `${n} pt${n === 1 ? "" : "s"}`;
